import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagGY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25 0c-4.42 0-8.571 1.149-12.174 3.161V46.84A24.885 24.885 0 0 0 25 49.999c13.807 0 25-11.192 25-25C50 11.194 38.807 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M12.9 3.12a25.051 25.051 0 0 0-3.973 2.732L28.074 25 8.927 44.147A25.064 25.064 0 0 0 12.9 46.88L50 25 12.9 3.12Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M10.788 4.432a25.154 25.154 0 0 0-2.192 1.703L25 25 8.596 43.865c.697.607 1.43 1.176 2.192 1.703L45.72 25 10.788 4.432Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#000",
  d: "M8.927 5.853c-.555.467-1.092.956-1.605 1.47L22.826 25 7.322 42.677c.513.513 1.05 1.003 1.605 1.47L28.074 25 8.927 5.853Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M7.322 7.322c-9.763 9.763-9.763 25.592 0 35.356L25 25 7.322 7.322Z"
}));
FlagGY.displayName = 'FlagGY';
export default withFlagWrapper(FlagGY);
//# sourceMappingURL=index.js.map